<template>
  <div class="border-0 mb-4">
   
    <div class=" bg-transparent border-0 pb-2 d-flex align-items-center justify-content-between">
      <h5 class="fw-bold mb-0 text-primary">
        <i class="bi bi-funnel-fill me-2"></i> {{ title }}
      </h5>
      <slot name="actions"></slot>
    </div>

    <div class=" py-2 ">
        <div class="row g-2 align-items-end">
            <!-- 🧩 Dynamic fields -->
            <div
            class="col-xl-2 col-md-4 col-12"
            v-for="(field, index) in dynamicFields"
            :key="index"
            >
            <!-- {{ field }} -->
            <label class="form-label mb-1">{{ field.label }}</label>

            <!-- Vue-select -->
            <vue-select
                v-if="field.type === 'select'"
                :options="field.options.length ? field.options : []"
                v-model="localFilter[field.model]"
                :placeholder="field.options.length ? (field.placeholder || 'Sélectionner...') : 'Chargement...'"
                :labelColumn="field.labelColumn || 'fullName'"
                :valueColumn="field.valueColumn || 'reference'"
                class="w-100"
                />


            <!-- Text input -->
            <input
                v-else-if="field.type === 'text'"
                v-model="localFilter[field.model]"
                type="text"
                class="form-control"
                :placeholder="field.placeholder || field.label"
            />

            <!-- Dropdown -->
            <select
                v-else-if="field.type === 'dropdown'"
                v-model="localFilter[field.model]"
                class="form-select"
            >
                <option value="">--</option>
                <option
                v-for="(opt, i) in field.options"
                :key="i"
                :value="opt.value"
                >
                {{ opt.label }}
                </option>
            </select>
            </div>

            <!-- 📅 Fixed fields -->
            <div class="col-auto" style="min-width: 180px !important;">
            <label class="form-label mb-1">Date Début <span class="text-danger">*</span></label>
            <input v-model="localFilter.startDate" type="date" class="form-control" />
            </div>

            <div class="col-auto" style="min-width: 180px !important;">
            <label class="form-label mb-1">Date Fin <span class="text-danger">*</span></label>
            <input v-model="localFilter.endDate" type="date" class="form-control" />
            </div>

            <!-- 🧭 Action buttons -->
            <div class="col-auto d-flex gap-2">
            <button class="btn btn-outline-secondary" @click="resetFilter">
                <i class="bi bi-arrow-repeat"></i>
            </button>
            <button class="btn btn-primary" @click="applyFilter">
                <i class="bi bi-search"></i>
            </button>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "FilterCard",
  props: {
    title: {
      type: String,
      default: "Filtrer les résultats",
    },
    filter: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localFilter: { ...this.filter },
    };
  },
  watch: {
    filter: {
      handler(val) {
        if (!val || typeof val !== "object") return;
        this.localFilter = { ...val };
      },
      deep: true,
    },
  },
  computed: {
    dynamicFields() {
      return this.fields.filter(
        (f) => f.model !== "startDate" && f.model !== "endDate"
      );
    },
  },
  methods: {
    applyFilter() {
      this.$emit("filter", this.localFilter);
    },
    resetFilter() {
      const resetData = {};
      this.fields.forEach((f) => (resetData[f.model] = ""));
      resetData.startDate = "";
      resetData.endDate = "";
      this.localFilter = resetData;
      this.$emit("reset", resetData);
    },
  },
};
</script>

<style scoped>
.filter-card {
  border-radius: 12px !important;
  background: #fff !important;
  transition: all 0.3s ease-in-out !important;
}
.filter-card:hover {
  box-shadow: 0 4px 12px rgba(4, 108, 193, 0.15) !important;
}
</style>
